import {
  FlexiReimbursementCreateClaimResponse,
  FlexiReimbursementCreateClaimVariables,
  FlexiReimbursementCreateClaimInput,
} from 'components/SalaryComponents/views/FlexibleBenefits/Claims/Create/types';
import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';

const createFlexiReimbursementClaimMutation = gql`
  mutation PayrollFlexiReimbursementCreateClaim($input: FlexiReimbursementCreateClaimInput!) {
    payrollFlexiReimbursementCreateClaim(input: $input) {
      component_id
      component_display_name
      bill_amount
      description
      code
      success
      message
    }
  }
`;

export const createFlexiReimbursementClaim = (input: FlexiReimbursementCreateClaimInput) => {
  return graphQLApi<FlexiReimbursementCreateClaimResponse, FlexiReimbursementCreateClaimVariables>({
    query: createFlexiReimbursementClaimMutation,
    queryVariables: { input },
  });
};
